import { DeleteOutlined, EditOutlined, SettingOutlined } from "@ant-design/icons";
import type { MenuProps } from "antd";

export const ENV_OPTIONS = [
  { label: "Local", value: "local" },
  { label: "Staging", value: "staging" },
  { label: "Production", value: "production" },
];

export const PROJECT_MENU_ITEMS: MenuProps["items"] = [
  { key: "edit", label: "Edit", icon: <EditOutlined /> },
  { key: "remove", label: "Remove project", icon: <DeleteOutlined />, danger: true },
];

export const ENV_MENU_ITEMS: MenuProps["items"] = [
  { key: "credentials", label: "Edit credentials", icon: <SettingOutlined /> },
  { key: "remove", label: "Remove", icon: <DeleteOutlined />, danger: true },
];

export const envBadgeColor = (name: string): string => {
  switch (name) {
    case "local": return "#6b7280";
    case "staging": return "#b45309";
    case "production": return "#9333ea";
    default: return "#1677ff";
  }
};
